import {MessageCircleDashed as MessageCircle} from 'lucide-react'
import { WHATSAPP_LINK } from '@/lib/constants'

function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-blue-600 text-white shadow-xl shadow-blue-600/30 hover:bg-blue-500 hover:scale-105 active:scale-100 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-blue-600 opacity-20 animate-ping" />
      <MessageCircle className="relative w-6 h-6" strokeWidth={2} />
    </a>
  )
}

export default FloatingWhatsApp
